import { ButtonProps, useToast } from "@chakra-ui/react";
import { Fragment, useState } from "react";
import ShiButton from "src/atoms/ShiButton";
import useMigration from "src/hooks/useMigration";
import MigrationModal from "./MigrationModal";

type MigrationButtonProps = ButtonProps & {
  apiEndpoint: string;
};

const MigrationButton = ({
  apiEndpoint,
  children,
  ...props
}: MigrationButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { triggerMigration, hasMigrationToken, isLoading } = useMigration();
  const toast = useToast();

  const handleConfirm = async () => {
    const ok = await triggerMigration(apiEndpoint);
    if (ok) {
      setIsSuccess(true);
    } else {
      toast({
        status: "error",
        duration: 6000,
        isClosable: true,
        title: "Un problème est survenu",
        description:
          "La migration n'a pas pu démarrer. Veuillez contacter le support client.",
      });
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsSuccess(false);
  };

  return (
    <Fragment>
      <MigrationModal
        isOpen={isOpen}
        isSuccess={isSuccess}
        isLoading={isLoading}
onClose={handleClose}
        onConfirm={handleConfirm}
      />
      <ShiButton
        hasArrow={false}
        onClick={() => setIsOpen(true)}
        isDisabled={!hasMigrationToken}
        sx={{
          "&[disabled], &[aria-disabled=true]": {
            "&:hover": { background: "btn-green-bg" },
          },
        }}
        {...(props as ButtonProps)}
      >
        {children}
      </ShiButton>
    </Fragment>
  );
};

export default MigrationButton;
